export default ({ app: { i18n } }, inject) => {
    inject('translateOptions', options =>
        options.map(option => ({
            ...option,
            text: option?.text || i18n.t(option._)
        }))
    );
};
